import type { EnumValueType } from '../../EnumUtils'
import { EnumUtils } from '../../EnumUtils'

/**
 * 售后原因常量
 */
export const AfterSalesReasonConstants = {
  NOT_RECEIVED: {
    value: 1,
    label: '未收到货',
  },
  DELAYED_DELIVERY: {
    value: 2,
    label: '超出预计送达时间太久',
  },
  DONT_WANT: {
    value: 3,
    label: '不想要了',
  },
  NOT_AS_DESCRIBED: {
    value: 4,
    label: '收到商品与描述严重不符',
  },
  ONLY_REFUND_BY_AGREEMENT: {
    value: 5,
    label: '协商一致仅退款',
  },
  WRONG_ITEM_SENT: {
    value: 6,
    label: '卖家发错货',
  },
  QUALITY_ISSUE: {
    value: 7,
    label: '商品质量问题',
  },
  MISSING_ITEMS: {
    value: 8,
    label: '商品少件',
  },
  EXPIRED: {
    value: 9,
    label: '商品过保质期',
  },
  OTHER: {
    value: 10,
    label: '其他',
  },
} as const

export type AfterSalesReasonValue = EnumValueType<typeof AfterSalesReasonConstants>

export const afterSalesReasonEnumUtils = new EnumUtils<AfterSalesReasonValue>(AfterSalesReasonConstants)

export default afterSalesReasonEnumUtils
